<app-template-number [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [max]="max" [regex]="regex" [commas]="commas" [label]="label" />
